/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_Next_Step_ErrorInputs */

const cs_sms_next_step_error = /** @type {(inputs: Sms_Next_Step_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další krok: obnovte stránku. Pokud problém trvá, zkontrolujte API logy (sms.smsStatus).`)
};

const en_sms_next_step_error = /** @type {(inputs: Sms_Next_Step_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next step: refresh the page. If it persists, check API logs (sms.smsStatus).`)
};

/**
* | output |
* | --- |
* | "Next step: refresh the page. If it persists, check API logs (sms.smsStatus)." |
*
* @param {Sms_Next_Step_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_next_step_error = /** @type {((inputs?: Sms_Next_Step_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_Next_Step_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_next_step_error(inputs)
	return cs_sms_next_step_error(inputs)
});